import $ from 'jquery';

$(document).ready(function () {

  function render_neighborhood_map($el) {
    var $markers = $el.find('.marker');

    var args = {
      zoom: 14,
      center: new google.maps.LatLng(0, 0),
      mapTypeId: google.maps.MapTypeId.ROADMAP,
      scrollwheel: true,
      styles: [
        { "elementType": "geometry", "stylers": [{ "color": "#f5f3f3" }] },
        { "elementType": "labels.icon", "stylers": [{ "visibility": "off" }] },

        { "elementType": "labels.text.fill", "stylers": [{ "color": "#1e4a59" }] },
        { "elementType": "labels.text.stroke", "stylers": [{ "color": "#f5f7f8" }, { "weight": 2 }] },

        { "featureType": "landscape.natural", "elementType": "geometry", "stylers": [{ "color": "#ddeae3" }] },
        { "featureType": "poi.park", "elementType": "geometry", "stylers": [{ "color": "#ddeae3" }] },
        { "featureType": "poi.park", "elementType": "labels.text.fill", "stylers": [{ "color": "#1e4a59" }] },

        { "featureType": "poi", "elementType": "geometry", "stylers": [{ "color": "#ddeae3" }] },
        { "featureType": "poi", "elementType": "labels.text.fill", "stylers": [{ "color": "#1e4a59" }] },

        { "featureType": "road", "elementType": "geometry", "stylers": [{ "color": "#ffffff" }] },
        { "featureType": "road", "elementType": "labels.text.fill", "stylers": [{ "color": "#78909c" }] },
        { "featureType": "road.highway", "elementType": "geometry", "stylers": [{ "color": "#ffffff" }] },
        { "featureType": "road.highway", "elementType": "labels.text.fill", "stylers": [{ "color": "#1e4a59" }] },
        { "featureType": "road.arterial", "elementType": "labels.text.fill", "stylers": [{ "color": "#1e4a59" }] },

        { "featureType": "transit.line", "elementType": "geometry", "stylers": [{ "color": "#cfdadf" }] },
        { "featureType": "transit.station", "elementType": "geometry", "stylers": [{ "color": "#ebf0f1" }] },

        { "featureType": "water", "elementType": "geometry", "stylers": [{ "color": "#d4e1e5" }] },
        { "featureType": "water", "elementType": "labels.text.fill", "stylers": [{ "color": "#1e4a59" }] }
      ]
    };

    var map = new google.maps.Map($el[0], args);
    map.markers = [];

    $markers.each(function (index) {
      add_neighborhood_marker($(this), map, index);
    });

    filter_neighborhood_markers('main', map);

    var $wrapper = $el.closest('.neighborhood-map-wrapper');

    $wrapper.find('.category-trigger').on('click', function (e) {
      e.preventDefault();

      var $parentBlock = $(this).closest('.category-block');
      var categoryId = $parentBlock.data('category-id');

      $wrapper.find('.category-block').not($parentBlock).removeClass('is-active')
        .find('.category-locations-list').slideUp();

      $parentBlock.toggleClass('is-active');
      $parentBlock.find('.category-locations-list').slideToggle();

      if ($parentBlock.hasClass('is-active')) {
        filter_neighborhood_markers(categoryId, map);
      } else {
        filter_neighborhood_markers('main', map);
      }
    });
  }

  var infowindow = new google.maps.InfoWindow();

  function createNumberedMarkerSvg(number) {
    var svg = '<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">' +
      '<circle cx="16" cy="16" r="14" fill="#1e4a59" stroke="#ffffff" stroke-width="2"/>' +
      '<text x="50%" y="55%" dominant-baseline="middle" text-anchor="middle" font-family="Arial, sans-serif" font-size="14px" font-weight="bold" fill="#ffffff">' + number + '</text>' +
      '</svg>';
    return 'data:image/svg+xml;base64,' + window.btoa(svg);
  }

  function getMainHubSvg() {
    var svg = '<svg id="hjk" xmlns="http://www.w3.org/2000/svg" width="39.229" height="55.096" viewBox="0 0 39.229 55.096">' +
      '<path id="137" d="M39.229,19.614c0,10.833-19.615,35.482-19.615,35.482S0,30.446,0,19.614a19.615,19.615,0,1,1,39.229,0" fill="#173a47"/>' +
      '</svg>';
    return 'data:image/svg+xml;utf8,' + encodeURIComponent(svg);
  }

  function add_neighborhood_marker($marker, map, index) {
    var lat = parseFloat($marker.attr('data-lat'));
    var lng = parseFloat($marker.attr('data-lng'));
    var customIconUrl = $marker.attr('data-marker-icon');

    if (isNaN(lat) || isNaN(lng)) {
      return;
    }

    var latlng = new google.maps.LatLng(lat, lng);
    var serviceId = $marker.attr('data-service-id');

    var markerOptions = {
      position: latlng,
      map: map
    };

    if (serviceId === 'main') {
      markerOptions.zIndex = 999;
      markerOptions.icon = {
        url: (customIconUrl && customIconUrl !== 'undefined') ? customIconUrl : getMainHubSvg(),
        scaledSize: new google.maps.Size(40, 55),
        anchor: new google.maps.Point(20, 55)
      };
    } else {
      var markerNumber = $marker.find('strong').text().split('.')[0].trim();
      if (!markerNumber || isNaN(markerNumber)) {
        markerNumber = "1";
      }
      markerOptions.icon = {
        url: createNumberedMarkerSvg(markerNumber),
        scaledSize: new google.maps.Size(32, 32),
        anchor: new google.maps.Point(16, 16)
      };
    }

    var marker = new google.maps.Marker(markerOptions);
    marker.serviceId = serviceId;

    map.markers.push(marker);

    if ($.trim($marker.html())) {
      google.maps.event.addListener(marker, 'click', function () {
        infowindow.setContent($marker.html());
        infowindow.open(map, marker);
      });
    }
  }

  function filter_neighborhood_markers(activeCategoryId, map) {
    var bounds = new google.maps.LatLngBounds();
    var visibleCount = 0;

    $.each(map.markers, function (i, marker) {
      if (marker.serviceId === 'main' || marker.serviceId == activeCategoryId) {
        marker.setVisible(true);
        bounds.extend(marker.getPosition());
        visibleCount++;
      } else {
        marker.setVisible(false);
      }
    });

    if (visibleCount === 1) {
      map.setCenter(bounds.getCenter());
      map.setZoom(15);
    } else {
      map.fitBounds(bounds);

      var listener = google.maps.event.addListener(map, 'idle', function () {
        if (map.getZoom() > 16) map.setZoom(15);
        google.maps.event.removeListener(listener);
      });
    }
  }

  $('.acf-map').each(function () {
    render_neighborhood_map($(this));
  });
});
